import {Typography, TypographyTags} from '@gwc/main'
import {forwardRef, memo} from 'react'

import {TypographyProps} from './Typography.types'

type Typographyv2Type = <C extends Function | TypographyTags = TypographyTags>(props: TypographyProps<C>) => JSX.Element

export const Typographyv2 = memo(
  forwardRef<HTMLElement, TypographyProps<TypographyTags>>(function Typographyv2<
    C extends Function | TypographyTags = TypographyTags,
  >({whiteSpace, color = 'main', ...props}: TypographyProps<C>, ref: React.Ref<HTMLElement>) {
    return <Typography ref={ref} {...props} color={color} style={{whiteSpace, ...props.style}} />
  }),
  // сложные дженерики в которые реакт не умеет
) as unknown as Typographyv2Type

export default Typographyv2
